import { createReducer, on } from '@ngrx/store';
import { MdmInstalledApplicationsApiActions } from './mdm-installed-applications.actions';
import { adapter, initialState } from './mdm-installed-applications.state';

export const mdmInstalledApplicationsFeatureKey = 'mdmInstalledApplications';

export const mdmInstalledApplicationsReducer = createReducer(
  initialState,
  on(MdmInstalledApplicationsApiActions.installedApplicationsLoaded, (state, { installedApplications, udid }) => {
    const cleared = adapter.removeMany((x) => x.udid == udid, state);
    return adapter.upsertMany(installedApplications, cleared);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectMdmInstalledApplicationsIds = selectIds;

export const selectMdmInstalledApplicationsEntities = selectEntities;

export const selectAllMdmInstalledApplications = selectAll;
